import validate from 'validate.js';


const constraints = {
    password: {
	presence: { 
	    message: 'Vstavi password'
	},
	length:{
	    minimum: 6,
	    tooShort: 'Minimalna dolžina je 6 črk'
	}
    },
    passwordConfirm: {
	presence: { 
	    message: 'Vstavi password'
	},
	equality: {
	    attribute: "password",
	    message: 'Password niso iste'
	},
	length:{
	    minimum: 6,
	    tooShort: 'Minimalna dolžina je 6 črk'
	}
    }


}

const PasswordUpdateValidator = ( fields ) => {

    return validate(fields, constraints, {fullMessages: false}) || {};
}

export default PasswordUpdateValidator ;



// WEBPACK FOOTER //
// ./src/validators/PasswordUpdateValidator.js